import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Tabs } from 'react-tabs';
import { TabsLayoutService } from '../../../services/tabslayout.service';

import './TabsLayout.css';

const TabsLayout = (props) => {

    const [footerHeight, setFooterHeight] = useState(props.defaultFooterHeight ? props.defaultFooterHeight : 50);
    const [_selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {

        const footerHeightService = TabsLayoutService.getFooterHeight().subscribe((data) => {
            setFooterHeight(data);
        })

        return () => {
            footerHeightService.unsubscribe();
        }

    }, [])

    useEffect(() => {
        setSelectedIndex(props.selectedIndex)
        setFooterHeight(props.defaultFooterHeight ? props.defaultFooterHeight : 50)
    }, [props.selectedIndex])


    const onSelectIndex = (index) => {
        if (props.onSelectIndex) {
            props.onSelectIndex(index)
        } else {
            setSelectedIndex(index);
        }
    };

    return (

        <Tabs selectedIndex={_selectedIndex ? _selectedIndex : 0} onSelect={(index) => onSelectIndex(index)}>
            <div style={{ height: '100%' }}>

                {props?.TabList && (
                    <div style={{ height: '50px' }}>
                        {props.TabList}
                    </div>
                )}

                <div className="as-tablayout-content" style={{ height: `calc(100% - ${footerHeight}px)` }} >
                    {props.TabPanel}
                </div>

            </div>
        </Tabs>
    );
}

export default TabsLayout;